<h1>{{locale.addNewChart}}</h1>

<div class="dialog">
  <form class="form" [formGroup]="form" (submit)="submit()">
    <iv-live-dropdown-new
      class="form__control form__dropdown-selector"
      formControlName="chartIdName"
      [templateField]="{list: 'name', input: 'name'}"
      [contentWidth]="true"
      [placeholder]="locale.selectTypeChart"
      [listValues]="listChartTypes"
      fullyDisclosed
    ></iv-live-dropdown-new>

    <ng-container *ngIf="selectedChart.id !== chartNameId.IV_DIFFERENCE && form.get(filterTypes.STOCK_ID)">
      <ng-container *ngTemplateOutlet="autocomplete; context: {control: form.get(filterTypes.STOCK_ID)}"></ng-container>
    </ng-container>

    <ng-container *ngIf="selectedChart">
      <!-- TODO: Когда TIME_RANGE будет больше D1 для SINGLE_CONTRACT_ANALYZER -> убрать -->
      <ng-container *ngIf="filters.get(filterTypes.TIME_RANGE) && selectedChart.id !== chartNameId.SINGLE_CONTRACT_ANALYZER">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.TIME_RANGE}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.EOD_TIME_RANGE)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.EOD_TIME_RANGE}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.V_MODE_TOGGLER)">
        <ng-container *ngTemplateOutlet="vWapToggle"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.IVX_TERM)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.OPTION_TYPE)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.OPTION_TYPE}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.TOTAL_OI_CHART_TYPE)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.TOTAL_OI_CHART_TYPE}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.HV_TERM)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.HV_TERM}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.MONEYNESS)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.REALTIME) && isMaturity">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.REALTIME}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.DATE_TIME)">
        <ng-container *ngTemplateOutlet="dateTimePicker"></ng-container>
      </ng-container>

      <ng-container *ngIf="selectedChart.id === chartNameId.IV_DIFFERENCE">
        <div class="controls-frame">
          <h3>{{locale.firstPoint}}</h3>

          <ng-container *ngIf="filters.get(filterTypes.STOCK_ID + '-first')">
            <ng-container *ngTemplateOutlet="autocomplete; context: {control: filters.get(filterTypes.STOCK_ID + '-first')}"></ng-container>
          </ng-container>

          <ng-container *ngIf="filters.get(filterTypes.IVX_TERM + '-first')">
            <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM + '-first'}"></ng-container>
          </ng-container>

          <ng-container *ngIf="filters.get(filterTypes.MONEYNESS + '-first')">
            <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS + '-first'}"></ng-container>
          </ng-container>
        </div>

        <div class="controls-frame">
          <h3>{{locale.secondPoint}}</h3>

          <ng-container *ngIf="filters.get(filterTypes.STOCK_ID + '-second')">
            <ng-container *ngTemplateOutlet="autocomplete; context: {control: filters.get(filterTypes.STOCK_ID + '-second')}"></ng-container>
          </ng-container>

          <ng-container *ngIf="filters.get(filterTypes.IVX_TERM + '-second')">
            <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.IVX_TERM + '-second'}"></ng-container>
          </ng-container>

          <ng-container *ngIf="filters.get(filterTypes.MONEYNESS + '-second')">
            <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.MONEYNESS + '-second'}"></ng-container>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.EXPIRATION_DATE)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.EXPIRATION_DATE}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.STRIKE)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.STRIKE}"></ng-container>
      </ng-container>

      <ng-container *ngIf="filters.get(filterTypes.SINGLE_CONTRACT_ANALYZER_TYPE)">
        <ng-container *ngTemplateOutlet="dropdown; context: {controlName: filterTypes.SINGLE_CONTRACT_ANALYZER_TYPE}"></ng-container>
      </ng-container>
    </ng-container>
  </form>

  <div class="button-container">
    <button
      class="iv-flat-button"
      (click)="submit()"
      statistic
      [statisticElementName]="'Add chart dialog button add'"
      [disabled]="form.invalid"
    >
      {{locale.addChart}}
    </button>
  </div>
  <div *ngIf="noData" class="no-data">
    {{errorText}}
  </div>
</div>

<div class="description" *ngIf="this.form.get('chartIdName').value">
  <span class="text">
    {{getChartDescription(selectedChart)}}
  </span>
</div>

<ng-template #autocomplete let-control="control">
  <ng-container [formGroup]="form">
    <iv-live-symbols-autocomplete
      class="form__control symbols-autocomplete-overrides"
      [formControl]="control"
      valueExpr="nameAndExchange"
      [dataSource]="listStocks"
      [showClearButton]="true"
      [placeholder]="locale.searchSymbol"
      (selectedItem)="autocompleteItemClick($event)"
      (valueChanged)="updateFormValidity($event, control)"
    ></iv-live-symbols-autocomplete>
  </ng-container>
</ng-template>

<ng-template #dropdown let-controlName="controlName">
  <ng-container [formGroup]="filters">
    <iv-live-dropdown-new
      class="form__control form__dropdown-selector"
      [class.form__control-disabled]="filters.disabled"
      [templateField]="dropdownTemplateField(controlName)"
      [formControlName]="controlName"
      [label]="getFilterName(controlName)"
      [contentWidth]="true"
      [listValues]="$any(filterPattern[controlName])"
      [isAutocomplete]="getFilterName(controlName) === 'Strike'"
      (onStrikeChanged)="onStrikeChanged($event)"
    ></iv-live-dropdown-new>
  </ng-container>
</ng-template>

<ng-template #vWapToggle>
  <ng-container [formGroup]="filters">
    <div
      tuiHintMode="onDark"
      tuiHintDirection="top-right"
      [tuiHint]="filters.get(filterTypes.V_MODE_TOGGLER).disabled ? locale.vWapHintNoData : locale.vWapHint"
    >
      <tui-checkbox-labeled
        class="form__control"
        [formControlName]="filterTypes.V_MODE_TOGGLER"
      >
        {{locale.showVWap}}
      </tui-checkbox-labeled>
    </div>
  </ng-container>
</ng-template>

<ng-template #dateTimePicker>
  <ng-container [formGroup]="filters">
    <iv-live-date-time-selector
      class="form__control form__date-time-picker"
      [formControl]="$any(filters.get(filterTypes.DATE_TIME))"
      [locale]="locale"
      [clearButton]="{date: true, time: false}"
      (isEod)="dateIsEod($event)"
    ></iv-live-date-time-selector>
  </ng-container>
</ng-template>
